// src/holladai/pages/Portfolio.js
import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useInventoryStats } from "../hooks/useInventoryStats";
import { useOooData } from "../hooks/useOooData";
import "./Dashboard.css";

// TODO: Can replace this with dynamic property fetching in the future
const HOTEL_IDS = [58404];

const PROPERTIES = {
  58404: "Echo Indy-Ameriplex",
  // 58563: "Echo Gallatin",
  // 58570: "Echo Madison",
};

export default function Portfolio() {
  const navigate = useNavigate();
  const location = useLocation();

  // Which stat to display (from URL query)
  const searchParams = new URLSearchParams(location.search);
  const statType = searchParams.get("stat") || "totalReserved";

  // Memoize hotel IDs to avoid unnecessary re-renders
  const hotelIds = useMemo(() => HOTEL_IDS, []);

  // Pick the right hook based on stat type
  const { data, loading, error } =
    statType === "oooRooms"
      ? useOooData(hotelIds)
      : useInventoryStats(hotelIds);

  // Helper to get display value per hotel
  const getValue = (hotelId) => {
    if (statType === "oooRooms") return data[hotelId]?.length || 0;
    return data[hotelId]?.[statType] || 0;
  };

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Portfolio</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {loading && <p>Loading portfolio stats...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <div className="stats-grid">
          {HOTEL_IDS.map((hotelId) => (
            <div
              key={hotelId}
              className="stat-card"
              onClick={() =>
                navigate(
                  `/holladai/portfolio/${hotelId}/detail?stat=${statType}`
                )
              }
            >
              <p className="stat-label">{PROPERTIES[hotelId]}</p>
              <p className="stat-value">{getValue(hotelId)}</p>
              <p className="stat-subtext">View details →</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
